<div class="grid grid-cols-12 gap-4 mt-2 items-stretch">
  <div class="col-span-12 lg:col-span-6 xl:col-span-6">
    <div class="card h-full">
      <div
        class="documentation-items-container flex justify-between items-center mt-2 mb-8"
      >
        <h5 class="text-2xl text-color dark:text-gray-100 font-semibold">
          Ajouter une nouvelle règle
        </h5>
      </div>

      <div class="space-y-4">
        <p class="text-gray-600 dark:text-gray-300">
          Utilisez les boutons ci-dessous pour ouvrir le formulaire de création
          de règle avec toutes les fonctionnalités avancées.
        </p>

        <div class="flex flex-col gap-3">
          <button
            class="p-button p-button-primary w-full"
            (click)="openCreateDialog()"
          >
            <i class="pi pi-plus mr-2"></i>
            Créer une nouvelle règle (avec brouillons)
          </button>

          <button
            class="p-button p-button-outlined w-full flex items-center justify-center gap-2"
            (click)="openSimpleCreateDialog()"
          >
            <i class="pi pi-plus"></i>
            Créer une nouvelle règle (simple)
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="col-span-12 lg:col-span-6 xl:col-span-6">
    <div class="card h-full">
      <div class="documentation-items-container">
        <h5
          class="text-2xl text-black dark:text-gray-100 font-semibold mt-2 mb-1"
        >
          Conseils pour proposer un modèle
        </h5>
      </div>

      <div class="main-container">
        <div>
          <h3 class="section-title dark:text-gray-100 text-lg mt-2">
            Types de modèles disponibles
          </h3>
          <ul class="styled-list">
            <li>
              <span class="list-item-highlight text-black dark:text-gray-100"
                >Prédictifs:</span
              >
              <span class="dark:text-gray-100">
                Anticiper les défaillances avant qu'elles ne surviennent
              </span>
            </li>
            <li>
              <span class="list-item-highlight text-black dark:text-gray-100"
                >Détection:</span
              >
              <span class="dark:text-gray-100">
                Identifier des anomalies en temps réel
              </span>
            </li>
            <li>
              <span class="list-item-highlight text-black dark:text-gray-100"
                >Surveillance:</span
              >
              <span class="dark:text-gray-100">
                Suivre l'évolution de paramètres critiques
              </span>
            </li>
            <li>
              <span class="list-item-highlight text-black dark:text-gray-100"
                >Optimisation:</span
              >
              <span class="text-color dark:text-gray-100">
                Améliorer les performances des équipements
              </span>
            </li>
          </ul>
        </div>

        <div>
          <h3 class="section-title text-lg mt-2">
            Informations utiles à inclure
          </h3>
          <ul class="styled-list">
            <li >
              Équipements concernés et leur localisation précise
            </li>
            <li >Problèmes récurrents observés</li>
            <li >
              Données disponibles (capteurs, historiques, etc.)
            </li>
            <li >
              Estimation des coûts évités ou bénéfices potentiels
            </li>
            <li >Contexte opérationnel spécifique</li>
          </ul>
        </div>

        <div>
          <h3 class="section-title text-lg mt-2">
            Bénéfices des modèles d'IA pour la maintenance
          </h3>
          <div class="grid-container">
            <div class="card-container card-blue">
              <p class="card-percentage text-blue-700 mb-1">-35%</p>
              <p class="card-description text-blue-600">
                Réduction temps d'arrêt
              </p>
            </div>
            <div class="card-container card-green">
              <p class="card-percentage text-green-700 mb-1">+22%</p>
              <p class="card-description text-green-600">
                Durée de vie des équipements
              </p>
            </div>
            <div class="card-container card-purple">
              <p class="card-percentage text-purple-700 mb-1">-28%</p>
              <p class="card-description text-purple-600">
                Coûts de maintenance
              </p>
            </div>
            <div class="card-container card-amber">
              <p class="card-percentage text-yellow-700 mb-1">+15%</p>
              <p class="card-description text-yellow-600">
                Productivité globale
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
